import { render, staticRenderFns } from "./CreatePayGrade.vue?vue&type=template&id=0068d53a"
import script from "./CreatePayGrade.vue?vue&type=script&lang=js"
export * from "./CreatePayGrade.vue?vue&type=script&lang=js"
import style0 from "./CreatePayGrade.vue?vue&type=style&index=0&id=0068d53a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports